import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-html-preview-dialog',
  styleUrls: ['./html-preview-dialog.component.scss'],
  templateUrl: './html-preview-dialog.component.html',
  standalone: false,
})
export class HtmlPreviewDialogComponent {
  phoneView = 'view_3';
  safeHtml: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<HtmlPreviewDialogComponent>,
    public changeDetectorRef: ChangeDetectorRef,
    public domSanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.safeHtml = this.domSanitizer.bypassSecurityTrustHtml(this.data.html);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  transform(): SafeHtml {
    return this.safeHtml;
  }

  changeView(id: string) {
    this.phoneView = `view_${id}`;
    this.changeDetectorRef.detectChanges();
  }
}
